// eslint-disable-next-line import/prefer-default-export
export const BILLING_MODEL = {
  NOT_AVAILABLE: 'n/a',
  ARRIVAL_AND_RETURN_TO_THE_STARTING_BASE: 'starting_base',
  BACK_TO_THE_STARTING_POINT: 'a-b-a',
};
